import React, { memo } from 'react'
import styles from './CommonDialog.module.scss'

type Props = {
    children: React.ReactNode
    zIndex?: number
    onCloseDialog?: () => void
    noPadding?: boolean
}

const CommonDialog: React.FC<Props> = memo((props: Props) => {
    const { onCloseDialog, children, zIndex, noPadding } = props

    function handleChildClick(event : React.MouseEvent<HTMLDivElement>) {
        event.stopPropagation();
    }

    return (
        <div 
        className={styles.container} 
        onClick={onCloseDialog} 
        style={
            zIndex ? { zIndex: zIndex } : {}
        }>
            <div 
            className={`${styles.dialogContainer} ${noPadding ? styles.noPadding : ""}`} 
            onClick={handleChildClick}
            style={
                zIndex ? { zIndex: zIndex + 1 } : {}
            }>
                {children}
            </div>
        </div>
    )
})

export default CommonDialog